import React from "react";
import { ToolRendererProps } from "./types";
import { WebSearchToolBlock } from "../WebSearchToolBlock";

export const WebSearchToolRenderer: React.FC<ToolRendererProps> = ({
  args,
  renderWithErrorIfFailed,
  getFallbackText,
}) => {
  const query = args?.query || args?.input?.query || "";

  return query
    ? renderWithErrorIfFailed(<WebSearchToolBlock query={query} />)
    : getFallbackText();
};

export const WebFetchToolRenderer: React.FC<ToolRendererProps> = ({
  args,
  renderWithErrorIfFailed,
  getFallbackText,
}) => {
  const url = args?.url || "";

  return url
    ? renderWithErrorIfFailed(
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs font-mono text-secondary-n-400 break-all hover:text-secondary-n-300 hover:underline transition-colors"
        >
          {url}
        </a>,
      )
    : getFallbackText();
};

export const SkillToolRenderer: React.FC<ToolRendererProps> = ({
  args,
  renderWithErrorIfFailed,
  getFallbackText,
}) => {
  const skillName = args?.skill || "";

  return skillName
    ? renderWithErrorIfFailed(
        <span className="text-xs text-secondary-n-400 capitalize">
          {skillName}
        </span>,
      )
    : getFallbackText();
};
